export const app_cache = {
  token: null,
  loggedIn: false,
};
